import { EnergyPulse, Wordmark } from "@elyxeer/ui";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { useAuthStore } from "~/store/auth-store";

/**
 * A member signed in successfully, but the account has no admin access. Signing in
 * worked, so this is a dead end with an exit — not an error to retry.
 */
export function NotAdminScreen() {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  const signOut = useAuthStore((state) => state.signOut);

  return (
    <Box
      data-testid="auth.not-admin"
      sx={{
        position: "relative",
        minHeight: "100dvh",
        backgroundColor: "background.paper",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingInline: 3,
        overflow: "hidden",
      }}
    >
      <EnergyPulse
        size={420}
        opacity={0.28}
        blur={12}
        sx={{ position: "absolute", top: -160, right: -140, zIndex: 0 }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          maxWidth: 420,
          width: "100%",
          marginInline: "auto",
        }}
      >
        <Wordmark size={26} />
        <Box>
          <Typography variant="H2" sx={{ color: "text.primary" }}>
            {t("auth.notAdminTitle")}
          </Typography>
          <Typography
            variant="T2"
            sx={{ color: "text.secondary", marginTop: 1.5 }}
          >
            {t("auth.notAdminSubtitle", { email: user?.email ?? "" })}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={() => void signOut()}
          data-testid="auth.sign-out"
          sx={{ alignSelf: "flex-start" }}
        >
          {t("shell.signOut")}
        </Button>
      </Box>
    </Box>
  );
}
